import { useState, useEffect, useDebugValue } from "react";

export function usePermissions(moduleName, profile) {
  const [permission, setPermission] = useState();

  useEffect(() => {
    const index = profile.assignedModules.findIndex(
      (module) => module.moduleName === moduleName
    );
    if (index > -1) {
      setPermission(profile.assignedModules[index]);
    } else {
      setPermission({
        create: false,
        read: false,
        update: false,
        delete: false,
      });
    }
  }, []);

  useDebugValue(permission ?? "loading...");

  return permission;
}
